const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const authService = {
  /**
   * Get JWT token - DEPRECATED with cookie-based auth
   * Returns null since tokens are now in HTTP-only cookies
   * Kept for backward compatibility
   */
  getToken() {
    // Tokens are in HTTP-only cookies, not accessible from JavaScript
    return null;
  },

  /**
   * Get current user from localStorage
   */
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Check if user is authenticated
   * Token is in HTTP-only cookie, we check for user data
   */
  isAuthenticated() {
    const user = this.getCurrentUser();
    console.log('authService.isAuthenticated:', !!user);
    return !!user;
  },

  /**
   * Get company ID
   */
  getCompanyId() {
    return localStorage.getItem('companyId');
  },

  /**
   * Attempt to refresh the access token using the HTTP-only refreshToken cookie.
   * Throws if the refresh token is also expired or invalid.
   */
  async refreshToken() {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include', // sends refreshToken cookie, receives new accessToken cookie
    });
    if (!response.ok) {
      throw new Error('Session expired');
    }
    return response;
  },

  /**
   * Logout user - calls backend to clear cookies
   */
  async logout() {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include', // Send cookies to clear them
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    
    // Clear localStorage (keep comprehensive list for compatibility)
    localStorage.removeItem('token'); // Legacy - may not exist
    localStorage.removeItem('refreshToken'); // Legacy - may not exist
    localStorage.removeItem('user');
    localStorage.removeItem('companyId');
    localStorage.removeItem('platformRole');
    localStorage.removeItem('companyRole');
    localStorage.removeItem('hasCmmsSubscription');
    localStorage.removeItem('hasChatbotSubscription');
    
    // Redirect to landing page login
    const landingUrl = process.env.REACT_APP_LANDING_URL || 'http://localhost:3000';
    window.location.href = `${landingUrl}/login`;
  },

  /**
   * Verify token (simplified - token is in HTTP-only cookie)
   */
  async verifyToken() {
    // Token is in HTTP-only cookie
    // Just check if user data exists
    const user = this.getCurrentUser();
    console.log('verifyToken: User exists:', !!user);
    return !!user;
  },

  /**
   * Make authenticated API request
   * Cookies are automatically sent with credentials: 'include'
   */
  async fetchWithAuth(url, options = {}) {
    return fetch(url, {
      ...options,
      credentials: 'include', // Important: Send cookies
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  },

  /**
   * Sync preferred language to backend (fire-and-forget)
   */
  async updateLanguage(lang) {
    try {
      await fetch('/api/users/me/language', {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ preferredLanguage: lang }),
      });
    } catch {
      // fire-and-forget — language sync failure must never disrupt UI
    }
  },
};